import { render } from "./OrderOverviewTable.vue?vue&type=template&id=0351099b&scoped=true&ts=true"
import script from "./OrderOverviewTable.vue?vue&type=script&lang=ts"
export * from "./OrderOverviewTable.vue?vue&type=script&lang=ts"

import "./OrderOverviewTable.vue?vue&type=style&index=0&id=0351099b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0351099b"]])

export default __exports__